import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../public/assets/leica-logo.png'


const _hoisted_1 = {
  class: "cx-home",
  id: "login-page"
}
const _hoisted_2 = { class: "main-nav" }
const _hoisted_3 = { class: "full-wrapper relative clearfix" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "nav-logo-wrap" }, [
  /*#__PURE__*/_createVNode("div", { class: "logo" }, [
    /*#__PURE__*/_createVNode("img", {
      class: "img-responsive",
      src: _imports_0,
      width: "173",
      height: "40",
      alt: ""
    })
  ])
], -1)
const _hoisted_5 = {
  class: "cx-footer",
  id: "login-footer"
}
const _hoisted_6 = {
  key: 1,
  class: "cx-footer__separator",
  href: "#"
}
const _hoisted_7 = {
  key: 3,
  class: "cx-footer__separator",
  href: "#"
}
const _hoisted_8 = {
  key: 4,
  href: "https://leica-geosystems.com/global/imprint",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_9 = {
  key: 5,
  class: "cx-footer__separator",
  href: "#"
}
const _hoisted_10 = {
  key: 6,
  href: "#",
  class: "ot-sdk-show-settings",
  rel: "noopener noreferrer"
}
const _hoisted_11 = {
  key: 7,
  class: "cx-footer__separator",
  href: "#"
}
const _hoisted_12 = {
  key: 8,
  href: "http://www.beian.miit.gov.cn",
  target: "_blank",
  rel: "noopener noreferrer"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_cx_language_picker = _resolveComponent("cx-language-picker")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("nav", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_cx_language_picker, {
          availableLanguages: _ctx.availableLanguages,
          onLanguageChanged: _ctx.changeLanguage
        }, null, 8, ["availableLanguages", "onLanguageChanged"])
      ])
    ]),
    _createVNode(_component_router_view),
    _createVNode("footer", _hoisted_5, [
      (_ctx.hasCookieMenu)
        ? (_openBlock(), _createBlock("a", {
            key: 0,
            href: _ctx.privacyPolicyUrl,
            target: "_blank",
            rel: "noopener noreferrer"
          }, _toDisplayString(_ctx.translations.privacy), 9, ["href"]))
        : _createCommentVNode("", true),
      (_ctx.hasCookieMenu)
        ? (_openBlock(), _createBlock("a", _hoisted_6, "|"))
        : _createCommentVNode("", true),
      (_ctx.hasCookieMenu)
        ? (_openBlock(), _createBlock("a", {
            key: 2,
            href: "#",
            onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.openCookiePolicy(...args)))
          }, _toDisplayString(_ctx.translations.cookie), 1))
        : _createCommentVNode("", true),
      (_ctx.hasCookieMenu)
        ? (_openBlock(), _createBlock("a", _hoisted_7, "|"))
        : _createCommentVNode("", true),
      (_ctx.hasCookieMenu)
        ? (_openBlock(), _createBlock("a", _hoisted_8, _toDisplayString(_ctx.translations.imprint), 1))
        : _createCommentVNode("", true),
      (_ctx.hasCookieMenu)
        ? (_openBlock(), _createBlock("a", _hoisted_9, "|"))
        : _createCommentVNode("", true),
      (_ctx.hasCookieMenu)
        ? (_openBlock(), _createBlock("a", _hoisted_10, _toDisplayString(_ctx.translations.settings), 1))
        : _createCommentVNode("", true),
      (_ctx.hasCookieMenu && _ctx.isChineseApp)
        ? (_openBlock(), _createBlock("a", _hoisted_11, "|"))
        : _createCommentVNode("", true),
      (_ctx.isChineseApp)
        ? (_openBlock(), _createBlock("a", _hoisted_12, "鲁ICP备20032292号"))
        : _createCommentVNode("", true)
    ])
  ]))
}